/**
 * Búsqueda de empresa por nombre o CUIT — Ticket Mantis #493.
 *
 * Criterio consistente con el buscador de Gestión de CVUs: matchea por razón
 * social (sin acentos, case-insensitive) o por CUIT (solo dígitos, tolerando
 * guiones en el tipeo y en el dato). Reutilizable en cualquier Autocomplete de
 * empresa (también aplica a #488).
 */

import { cuitDigits } from './format';

export interface EmpresaOpcion {
  id: string;
  razon_social: string;
  cuit: string;
}

/** Normaliza a minúsculas y sin acentos para comparar texto. */
export function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}

/**
 * ¿La empresa coincide con lo tipeado? Matchea por razón social (sin acentos,
 * case-insensitive) o por CUIT (solo dígitos; umbral de 2 para no matchear con
 * un solo caracter).
 */
export function empresaCoincide(empresa: EmpresaOpcion, query: string): boolean {
  const q = normalizar(query.trim());
  if (!q) return true;
  if (normalizar(empresa.razon_social).includes(q)) return true;
  const qDigits = query.replace(/\D/g, '');
  if (qDigits.length >= 2 && cuitDigits(empresa.cuit).includes(qDigits)) return true;
  return false;
}
